import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Button, Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import TableComponent from '../../components/Table/TableComponent';
import GenericLoader from '../../components/Loader/GenericLoader';
import './Normalization.css';
import {
  getConsolidatedTimingsWithFlag,
  getHolidays,
} from '../../services/TimingService';
import moment from 'moment';
import NormalizationSideDrawer from './NormalizationSideDrawer';
import { getUserData } from '../../services/UserService';
import '../../App.css';
import {
  getConsolidatedTimings,
  getSummary,
} from '../../services/TimingService';
import {
  RESET_DATE_RANGE,
  TimesheetsComponentLoaderAttribute,
} from '../../constants';

import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import MyLoader from '../Timesheets/TimingLoader/Timing_Loader';
import { msToTime } from '../../utils/TimeConversionFunctions';
import {
  resetFilterDataState,
  setFilterConfig,
} from '../../modules/filter/filterAction';
import GenericFilterDrawer from '../../components/GenericFilter/GenericFilterDrawer';
const dt = new Date(new Date().getFullYear(), new Date().getMonth(), 2)
  .toISOString()
  .slice(0, 10);
const Normalization = (props) => {
  const [pageSize, setPageSize] = useState(5);
  const people = useSelector((state) => state.peopleState);
  const currentUserId = KeycloakService.getUserDetail();
  const [loader, setLoader] = React.useState(true);
  const [summaryloader, setSummaryLoader] = React.useState(true);
  const [slotSelectDate, setSlotSelectDate] = React.useState(new Date());
  const [drawerState, setDrawerState] = React.useState({ right: false });
  const [monthlyTimings, setMonthlyTimings] = useState([]);
  const [consolidatedPieData, setConsolidatedPieData] = useState([]);
  const [totalHours, setTotalHours] = useState();
  const [officeHours, setOfficeHours] = useState();
  const [externalHours, setExternalHours] = useState();
  const [wfhHours, setWfhHours] = useState();
  const [expectedHours, setExpectedHours] = useState();
  const [employeeId, setEmployeeId] = useState('');
  const location = useLocation();
  const [slotDate, setSlotDate] = useState(new Date(props.slotSelectDate));
  const [page, setPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState();
  const [flag, setFlag] = useState(null);
  const [pageNo, setPageNo] = React.useState(0);
  const [refreshPage, setRefreshPage] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);

  const filterState = useSelector((state) => state.filterState);

  const emptyFilterData = {
    employeeName: '',
    startDate: '',
    endDate: '',
  };

  const [showError, setShowError] = useState(false);
  const [showError1, setShowError1] = useState(false);

  const navigate = useNavigate();
  const getUsersName = async (id) => {
    const toGetUser = await getUserData(id);

    if (toGetUser.isError === false) {
      const employeeName1 =
        toGetUser.data.firstName + ' ' + toGetUser.data.lastName;
      return toGetUser.data.firstName == undefined &&
        toGetUser.data.lastName == undefined
        ? 'NA'
        : employeeName1;
    }
    if (toGetUser.status !== 200) {
      dipatchNotification(toGetUser.type, toGetUser.message);
    }
  };
  const [rows, setRows] = React.useState([]);
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const [consolidatedTimingData, setConsolidatedTimingData] = React.useState(
    [],
  );

  const getData = async (eid) => {
    try {
      const consolidatedTimingsWithFlagResponse =
        await getConsolidatedTimingsWithFlag(
          pageSize,
          pageNo,
          filterState?.employeeId,
          filterState,
        );
      if (!consolidatedTimingsWithFlagResponse.data) {
        return;
      }

      for await (let element of consolidatedTimingsWithFlagResponse.data
        .content) {
        const id = element.employeeId;
        element.employeeName = await getUsersName(id);
      }

      consolidatedTimingsWithFlagResponse.data.content.forEach((element) => {
        element.date1 = element.date;

        let objectDate = new Date(element.date);

        let day = objectDate.getDate();

        let month = objectDate.getMonth();

        let year = objectDate.getFullYear();
        let format4 = `${day}-${month + 1}-${year}`;

        element.date = format4;
        element.officeHrs
          ? (element.officeHrs = timeFormater(element.officeHrs))
          : (element.officeHrs = 'NA');

        element.wfhHrs
          ? (element.wfhHrs = timeFormater(element.wfhHrs))
          : (element.wfhHrs = 'NA');

        element.totalHrs
          ? (element.totalHrs = timeFormater(element.totalHrs))
          : (element.totalHrs = 'NA');
      });
      if (consolidatedTimingsWithFlagResponse.isError == false) {
        // if (consolidatedTimingsWithFlagResponse.data.numberOfElements == 0) {
        //   pageChange(null, 1);
        // }
        setTotalPage(consolidatedTimingsWithFlagResponse.data.totalPages);

        setRows(() => consolidatedTimingsWithFlagResponse.data.content);
      }
      setConsolidatedTimingData(
        consolidatedTimingsWithFlagResponse.data.content,
      );
      if (consolidatedTimingsWithFlagResponse.data.content.length > 0) {
        setTotalPage(consolidatedTimingsWithFlagResponse.data.totalPages);
      } else {
        setTotalPage(1);
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  const timeFormater = (time) => {
    let d = Number(time / 1000);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? ' hr, ' : ' hrs, ') : '';
    var mDisplay = m > 0 ? m + (m == 1 ? ' min, ' : ' min, ') : '';
    var sDisplay = s > 0 ? s + (s == 1 ? ' sec' : ' sec') : '';
    return hDisplay + mDisplay + sDisplay;
  };
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 2)
      .toISOString()
      .slice(0, 10),
  );
  const [endDate, setEndDate] = useState(
    startDate === dt
      ? moment(new Date()).format('YYYY-MM-DD')
      : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
          .toISOString()
          .slice(0, 10),
  );

  const [holidayDate, setHolidayDate] = useState([]);
  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: 'SHOW_NOTIFICATION',
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getHoliday = async () => {
    const holidayList = await getHolidays(
      new Date(
        new Date(startDate).getFullYear(),
        new Date(startDate).getMonth(),
        2,
      )
        .toISOString()
        .slice(0, 10),
      new Date(
        new Date(endDate).getFullYear(),
        new Date(endDate).getMonth() + 1,
        1,
      )
        .toISOString()
        .slice(0, 10),
    );
    if (holidayList.isError === false) {
      setHolidayDate(holidayList.data);
      return holidayList.data;
    }
  };

  const displaySummary = async () => {
    const summaryData = await getSummary(
      startDate,
      endDate,
      people.id === '' ? currentUserId : people.id,
    );
    if (summaryData.isError === false) {
      setExternalHours(msToTime(summaryData.data.totalExternalHours));
      setOfficeHours(msToTime(summaryData.data.totalOfficeHours));
      setWfhHours(msToTime(summaryData.data.totalWfhHours));
      setTotalHours(msToTime(summaryData.data.totalHours));
      setExpectedHours(summaryData.data.expectedHours);
      setSummaryLoader(false);
      setLoader(false);
    }
    setLoader(false);
    if (summaryData.status !== 200) {
      dipatchNotification(summaryData.type, summaryData.message);
    }
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefreshPage(!refreshPage);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefreshPage(!refreshPage);
  };

  const consolidatedTimings = async () => {
    const consolidatedResponse = await getConsolidatedTimings(
      people.id === '' ? currentUserId : people.id,
      startDate,
      endDate,
    );
    if (consolidatedResponse.isError === false) {
      const holidayList = await getHoliday();
      setStatesFunction(consolidatedResponse, holidayList);
    }
    if (consolidatedResponse.status !== 200) {
      dipatchNotification(
        consolidatedResponse.type,
        consolidatedResponse.message,
      );
    }
  };

  const setStatesFunction = (consolidatedResponse, holidays) => {
    const holidayEvents = holidays?.map((list) => {
      return {
        holiday: list.occasion,
        date: list.date,
        flag: null,
      };
    });
    setMonthlyTimings((timings) => [
      ...consolidatedResponse.data.content,
      ...holidayEvents,
    ]);
  };

  const toggleDrawer = useCallback((anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setDrawerState({ ...drawerState, [anchor]: open });
  });

  const getEmployeeIdAndDate = (row) => {
    setEmployeeId(row.employeeId);
    setSlotSelectDate(row.date1);
    setSlotDate(row.date1);
    setFlag(row.flag);
    setDrawerState({ right: true });
  };
  const handleFilterIconClick = () => {
    setOpenDrawer(!openDrawer);
  };

  const columns = [
    { field: 'employeeName', headerName: ' EmployeeName', width: 150 },
    { field: 'date', headerName: 'Date', width: 120 },
    { field: 'flag', headerName: 'Flag', width: 220 },
    { field: 'officeHrs', headerName: 'WfoHrs ', width: 125 },
    { field: 'wfhHrs', headerName: ' WfhHrs', width: 125 },
    { field: 'totalHrs', headerName: ' TotalHrs', width: 125 },
    {
      field: 'action',
      headerName: ' Action',
      width: 120,
      renderCell: (params) => (
        <>
          <Button
            size="small"
            className="NormalizeButton"
            onClick={() => getEmployeeIdAndDate(params.row)}
          >
            Normalize
          </Button>
        </>
      ),
    },
  ];

  const filterConfiguration = {
    autoComplete: [['Search Employee', 'employee']],
  };

  const resetThings = () => {
    dispatch(setFilterConfig(filterConfiguration));
    dispatch({
      type: RESET_DATE_RANGE,
    });
    dispatch(resetFilterDataState());
  };
  const prevDate = new Date(
    new Date(props.slotSelectDate).getFullYear(),
    new Date(props.slotSelectDate).getMonth(),
    new Date(props.slotSelectDate).getDate() - 1,
  );
  const nextDate = new Date(
    new Date(props.slotSelectDate).getFullYear(),
    new Date(props.slotSelectDate).getMonth(),
    new Date(props.slotSelectDate).getDate() + 1,
  );

  const formatDate = (date) => {
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  };

  const handleDateChange = (amount) => {
    const newDate = new Date(slotDate);
    newDate.setDate(newDate.getDate() + amount);
    if (newDate !== prevDate || nextDate) setSlotDate(formatDate(newDate));
  };

  const [resetFilter, setResetFilter] = useState(false);

  useEffect(() => {
    resetThings();
    setResetFilter(true);
  }, []);

  const temp = useMemo(() => {
    pageChange(null, 1);
  }, [filterState]);

  // useEffect(() => {
  //   getData();
  // }, []);
  useEffect(() => {
    if (resetFilter || isEdit) {
      getData();
      setIsEdit(false);
    }
  }, [refreshPage, resetFilter, isEdit]);
  useEffect(() => {
    consolidatedTimings();
    displaySummary();
  }, [startDate, endDate]);

  return (
    <div>
      {loader ? (
        <div style={{ height: '80vh', overflow: 'hidden' }}>
          <GenericLoader rectAttributes={TimesheetsComponentLoaderAttribute} />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <Box className="main-content-div">
            {loader ? (
              <Box>
                <MyLoader
                  showError={showError1}
                  setShowError={setShowError1}
                  style={{ width: '100%' }}
                />
              </Box>
            ) : (
              <Box>
                <Grid
                  container
                  className="head-title-text"
                  sx={{ alignItems: 'center' }}
                >
                  <Grid item md={12}>
                    <Grid
                      className="align-container-inline"
                      sx={{ alignItems: 'center', mr: 4, ml: 4 }}
                    >
                      {<GenericFilterDrawer />}
                    </Grid>
                  </Grid>
                </Grid>

                <TableComponent
                  loader={loader}
                  TableRows={consolidatedTimingData}
                  TableColumns={columns}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                  totalPage={totalPage}
                  page={page}
                  pageChange={pageChange}
                />
                {drawerState.right && (
                  <NormalizationSideDrawer
                    setIsEdit={setIsEdit}
                    employeeId={employeeId}
                    flag={flag}
                    closeDrawer={toggleDrawer}
                    drawerOpenFlag={drawerState.right}
                    selectedDate={slotDate}
                    constantDate={slotSelectDate}
                    handleDateChange={handleDateChange}
                    monthlyTimings={monthlyTimings}
                    consolidatedPieData={consolidatedPieData}
                  />
                )}
              </Box>
            )}
          </Box>
        </Box>
      )}
    </div>
  );
};

export default Normalization;
